const backupApiUrl = 'https://gwweb-prod-glide.tech.rcimobility.com/api';
const backUpEnv = 'prod';

function safe(f) {
  try {
    return f();
  } catch (e) {}
}

function getAppObj() {
  return safe(() => window.APP) || {};
}

function getApiUrl() {
  const { apiUrl } = getAppObj();
  if (apiUrl) return apiUrl;

  const sessionApiUrl = safe(() => window.sessionStorage.getItem('API_URL'));
  if (sessionApiUrl) return sessionApiUrl;
  
  return backupApiUrl;
}

/**
 * Polls for an API URL to be available on window.APP.apiUrl or sessionStorage.API_URL.
 * Resolves with the found URL or the backupApiUrl after timeout.
 * @param {number} timeoutMs Total time to wait before falling back (default 3000ms)
 * @param {number} intervalMs Polling interval in ms (default 100ms)
 * @returns {Promise<string>}
 */
function getApiUrlAsync(timeoutMs = 3000, intervalMs = 100) {
  return new Promise((resolve) => {
    const start = Date.now();

    const tryGet = () => {
      const url = getApiUrl();
      if (url && url !== backupApiUrl) {
        return resolve(url);
      }

      if (Date.now() - start >= timeoutMs) {
        return resolve(getApiUrl());
      }

      setTimeout(tryGet, intervalMs);
    };

    tryGet();
  });
}

function getLocalEnv() {
  if (getApiUrl().includes('-prod-')) {
    return 'prod';
  } else if (getApiUrl().includes('-dev-')) {
    return 'dev';
  } else if (getApiUrl().includes('-valid-')) {
    return 'valid';
  } else if (getApiUrl().includes('-staging-')) {
    return 'staging';
  }
}

function isLocalEnv() {
  return process.env.NODE_ENV === 'development';
}

function isTestEnv(config) {
  const { env } = config;
  return env && env !== 'prod';
}

function setLocalData(config) {
  return setDevData(config);
}

function setEnvData(config) {
  Object.assign(config, getAppObj().settings);

  if (isTestEnv(config)) {
    setDevData(config);
  }

  return config;
}

function setDevData(config) {
  config.awsBrandsMapFileName = 'brandsMapDev.json';
  return config;
}

function getConfig() {
  const defaultConfig = {
    bookingsLimit: 4,
    amountToTake: '2,00',
    geoIpUrl: 'https://ip2c.org/self',
    awsBaseUrl: 'https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app',
    awsCompanyFolder: 'super-company',
    awsBrandsMapFileName: 'brandsMap.json',
    awsBrandsSelectFileName: 'brandsSelect.json',
    gMapsApiKey: 'AIzaSyDBcYCWGegc-v4Bamwnb-HQ2z2wS3ykH-s',
    mapboxEndpoint: 'https://api.mapbox.com/geocoding/v5',
    mapboxApiKey:
      'pk.eyJ1Ijoib2xlZy1rdXoiLCJhIjoiY2wycmR2ejd2MDFwNDNqbWd0YzRuNGZiaiJ9.Pg-UmverhwsJyzQNTizNGg',
    mapboxUrl: 'https://www.mapbox.com/search-service',
    minimumBookingDurationMinutes: 30,
    appLoaderMinTime: 500,
    fileSizeLimitInMb: 5,
    luminosityRatio: 0.5,
    env: backUpEnv,
    getLocalEnv,
    getApiUrl,
    getApiUrlAsync
  };

  if (isLocalEnv()) {
    return setLocalData(defaultConfig);
  }

  return setEnvData(defaultConfig);
}

module.exports = getConfig();
